import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

// CATEGORY 5
const api = {
  getWasteGeneratedInOperationsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/waste-generated-in-operations/items`,
      config).then(({ data }) => data);
  },

  addWasteGeneratedInOperationsItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/waste-generated-in-operations/items`, data, headers)
      .then(({ data }) => data);
  },

  updateWasteGeneratedInOperationsItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/waste-generated-in-operations/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteWasteGeneratedInOperationsItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/waste-generated-in-operations/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importWasteGeneratedInOperationsItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/waste-generated-in-operations/items/import`, data, headers).then(({ data }) => data);
  },

  getTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/waste-generated-in-operations/items/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category5_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;
